<template>
    <v-layout justify-center>
        <v-responsive max-width="1140px" width="100%" height="100%" class="px-1">
            <div class="headline text-start mt-8">
                <span>소송 / 분쟁</span>
            </div>

            <section class="mt-4">
                <div class="subtitle-2 font-weight-bold">소개글</div>

                <v-card class="mt-1">
                    <v-card-text>
                        <v-textarea  v-model="practice.section1.txt" outlined hide-details />
                    </v-card-text>
                </v-card>
            </section>

            <section class="mt-8">
                <v-layout align-end>
                    <div class="subtitle-2 font-weight-bold">주요 업무분야</div>
                    <v-spacer/>
                </v-layout>

                <v-card class="mt-2">
                    <v-row  align="center">
                        <v-col cols="2"></v-col>
                        <v-col></v-col>
                        <v-col cols="auto">
                            <v-btn small color="primary" elevation="4" class="mr-4" @click="setItem"><v-icon left size="16">mdi-plus</v-icon>항목 추가</v-btn>
                            <v-btn small color="red" elevation="4" outlined class="mr-4" @click="deleteItem"><v-icon left size="16">mdi-delete-outline</v-icon>항목 삭제</v-btn>
                        </v-col>
                    </v-row>

                    <div v-for="section2, index in practice.section2" :key="index">
                        <v-divider />
                        <v-card-text class="py-0">
                            <template >
                                <v-row  align="center">
                                    <v-col cols="2">
                                        <v-textarea v-model="section2.title" rows="1" dense outlined hide-details />
                                    </v-col>
                                    <v-col>
                                        <v-col v-for="column, index in section2.columns" :key="index">
                                            <v-textarea v-model="column.txt" rows="1" dense outlined hide-details />
                                        </v-col>
                                    </v-col>
                                    <v-col cols="auto">
                                        <v-col>
                                            <v-btn small color="primary" elevation="4" @click="setColumn(index)"><v-icon left size="16">mdi-plus</v-icon>행 추가</v-btn>
                                        </v-col>
                                        <v-col>
                                            <v-btn small outlined color="red" @click="deleteColumn(index)" ><v-icon left size="16">mdi-delete-outline</v-icon>행 삭제</v-btn>
                                        </v-col>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-card-text>
                    </div>
                </v-card>
            </section>

            <v-row justify="center" class="mx-1 my-4">
                <v-col md="auto" sm="auto">
                    <v-btn dark color="blue darken-2" elevation="4" @click="save()">저장</v-btn>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
export default {
    data() {
        return {

            practice: {
                section1: {
                    txt: null
                },

                section2: [
                    { title: null, columns: [{ txt: null }] },
                ],

                code: "dispute",
                local: this.local
            },

        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init(){
            let { practice } = await api.console.practice.get({ params: { code: "international", local: this.local }});
            this.practice = practice;
        },
        async save(){
            await api.console.practice.put(this.practice);

            alert("저장되었습니다");
        },
        setItem() {
            this.practice.section2.push({ title: null, columns: [{ txt: null }] });
        },
        deleteItem() {
            this.practice.section2.pop();
        },
        setColumn(index) {
            this.practice.section2[index].columns.push({ txt: null })
        },
        deleteColumn(index) {
            this.practice.section2[index].columns.pop()
        }
    },
    computed: {
        local() {
            return this.$route.query.local;
        }
    }
};
</script>
